<div class="container about-shell">
  <div class="about-story">
    <div class="about-copy">
      <p class="eyebrow">About Tricore</p>
      <p>
        Tricore Holdings is not a traditional investment firm or a simple tech house. We are a Multi-Industry Venture Builder that identifies potential across the entire economic spectrum. Whether it’s revolutionizing sustainable agriculture, modernizing textile manufacturing, or scaling digital platforms, we provide the operational backbone for ambitious founders.
      </p>
      <p>
        Our model is built on Strategic Partnership. We seek out entrepreneurs who possess deep industry expertise but require a powerhouse partner to handle the complexities of scaling, technology integration, and organizational design. We don’t just fund your idea—we enter the trenches with you to build a resilient, future-proof empire.
      </p>
    </div>

    <div class="about-feature">
      <h3>{{ feature.title }}</h3>
      <div class="feature-image-frame">
        <img [src]="feature.image" alt="Tricore team collaboration" />
      </div>
    </div>
  </div>

  <div class="about-divider" aria-hidden="true"></div>

  <div class="about-foundation">
    <div class="section-header">
      <p class="eyebrow">Our Partnership Framework</p>
      <h2>The Tricore Partnership Framework</h2>
      <p>
        We partner with visionaries who are ready to move beyond "small idea" and toward "market leadership."
      </p>
    </div>

    <div class="about-cards">
      <div class="about-card" *ngFor="let item of highlights; let i = index">
      <div class="about-icon" aria-hidden="true">
        <svg *ngIf="item.icon === 'integrity'" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ef1748"><path d="M160-120v-80h480v80H160Zm226-194L160-540l84-86 228 226-86 86Zm254-254L414-796l86-84 226 226-86 86Zm184 408L302-682l56-56 522 522-56 56Z"/></svg>
        <svg *ngIf="item.icon === 'innovation'" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ef1748"><path d="M440-800v-120h80v120h-80Zm0 760v-120h80v120h-80Zm360-400v-80h120v80H800Zm-760 0v-80h120v80H40Zm708-252-56-56 70-72 58 58-72 70ZM198-140l-58-58 72-70 56 56-70 72Zm564 0-70-72 56-56 72 70-58 58ZM212-692l-72-70 58-58 70 72-56 56Zm98 382q-70-70-70-170t70-170q70-70 170-70t170 70q70 70 70 170t-70 170q-70 70-170 70t-170-70Zm283.5-56.5Q640-413 640-480t-46.5-113.5Q547-640 480-640t-113.5 46.5Q320-547 320-480t46.5 113.5Q413-320 480-320t113.5-46.5ZM480-480Z"/></svg>
        <svg *ngIf="item.icon === 'precision'" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ef1748"><path d="M440-42v-80q-125-14-214.5-103.5T122-440H42v-80h80q14-125 103.5-214.5T440-838v-80h80v80q125 14 214.5 103.5T838-520h80v80h-80q-14 125-103.5 214.5T520-122v80h-80Zm238-240q82-82 82-198t-82-198q-82-82-198-82t-198 82q-82 82-82 198t82 198q82 82 198 82t198-82Zm-311-85q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47Zm169.5-56.5Q560-447 560-480t-23.5-56.5Q513-560 480-560t-56.5 23.5Q400-513 400-480t23.5 56.5Q447-400 480-400t56.5-23.5ZM480-480Z"/></svg>
      </div>
        <h3>{{ item.title }}</h3>
        <p>{{ item.description }}</p>
      </div>
    </div>
  </div>
</div>
